/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import manufacturing from "assets/images/manufacturing.jpg";
import engineering from "assets/images/engineering.jpg";
import construction from "assets/images/construction.jpg";
import mining from "assets/images/mining.jpg";
import energy from "assets/images/energy.jpg";
import retail from "assets/images/retail.jpg";
import oil from "assets/images/oil.jpg";

export default [
  {
    image: manufacturing,
    name: "Manufacturing",
  },
  {
    image: engineering,
    name: "Engineering",
    route: "/pages/landing-pages/contact-us",
  },
  {
    image: construction,
    name: "Construction",
  },
  {
    image: mining,
    name: "Mining",
  },
  {
    image: energy,
    name: "Energy & Power",
  },
  {
    image: retail,
    name: "Retail & Corporate",
  },
  {
    image: oil,
    name: "Oil & Gas",
  },
];
